import { Alert, Card, Row, Col } from "react-bootstrap"
import { DisplayText } from "../utils/components"

export default function EventListItem({ event, onClick }) {
  return (
    <Card
      className="mb-3 cursor-pointer"
      onClick={onClick}
      style={{ cursor: "pointer" }}
    >
      <Card.Body className="p-0">
        <Row className="g-0">
          <Col
            xs={4}
            md={3}
          >
            <img
              src={event.image}
              alt={event.name}
              className="img-fluid rounded-start"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          </Col>
          <Col
            xs={8}
            md={9}
          >
            <div className="p-3">
              <h5 className="mb-2">{event.name}</h5>
              <p className="mb-0 text-muted small">
                {event.description?.length > 150
                  ? `${event.description.substring(0, 150)}...`
                  : event.description}
              </p>
            </div>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  )
}

export function EventDetails({ event }) {
  return (
    <Card>
      <Card.Img
        variant="top"
        src={event.image}
      />
      <Card.Body>
        <Alert variant={"success"}>
          <h5>Event Code: {event.code}</h5>
          <p className={"text-muted"}>
            Ensure that this event code matches the code advertised by the event
            organizer, before purchasing a ticket
          </p>
        </Alert>
        <Card.Title className={"text-primary"}>{event.datetime}</Card.Title>
        <div className={"mt-3"}>
          <h4>{event.name}</h4>
          <h5 className={"text-muted mt-1"}>{event.organizer.name}</h5>
          <h6 className={"mt-3 mb-2"}>
            <DisplayText text={event.description} />
          </h6>
          <br />
          <strong>Address:</strong>
          <h6>{event.full_address}</h6>
        </div>
      </Card.Body>
    </Card>
  )
}
